import script from "./TableCampaignExpired.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableCampaignExpired.vue?vue&type=script&setup=true&lang=ts"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./TableCampaignExpired.vue?vue&type=style&index=1&id=ec82fab2&lang=css"

const __exports__ = script;

export default __exports__